import * as BUILD_CAPABILITIES from '#pplx/frontend/deployment-capabilities/build.js';
import { MIN_VERSION_REFRESH_URL } from '#pplx/frontend/r2-assets/r2Asset.js';
const MIN_RELOAD_WINDOW_MS = 5 * 60 * 1e3;
const MAX_RELOAD_WINDOW_MS = 30 * 60 * 1e3;
function isPositiveNumber(value) {
    return typeof value === 'number' && Number.isFinite(value) && value > 0;
}
export function parseMinVersionRefresh(body) {
    if (typeof body !== 'object' || body === null)
        return null;
    const { minBuildTimestamp, reloadWindowMs } = body;
    if (!isPositiveNumber(minBuildTimestamp) || !isPositiveNumber(reloadWindowMs))
        return null;
    return {
        minBuildTimestamp,
        reloadWindowMs: Math.min(MAX_RELOAD_WINDOW_MS, Math.max(MIN_RELOAD_WINDOW_MS, reloadWindowMs)),
    };
}
/** Builds with an unknown (0) timestamp are never below the minimum. */
export function isBelowMinVersionRefresh(buildTimestamp, minVersionRefresh) {
    return buildTimestamp > 0 && buildTimestamp < minVersionRefresh.minBuildTimestamp;
}
// Uploaded on merge by agi-code-frontend-upload-min-version-refresh; any other response means no minimum.
export async function getMinVersionRefresh() {
    if (!BUILD_CAPABILITIES.cdnRefresh)
        return null;
    // The object is uploaded with `Cache-Control: no-store`; this also bypasses the HTTP cache
    // if an intermediary ignores that.
    const resp = await fetch(MIN_VERSION_REFRESH_URL, { cache: 'no-store' });
    if (!resp.ok)
        return null;
    return parseMinVersionRefresh(await resp.json().catch(() => null));
}
//# sourceMappingURL=getMinVersionRefresh.js.map